import { useMemo } from 'react';

import { useIntl } from 'react-intl';

import { getTranslatedItemTitle } from '../prebuilt/config-items/config-items';
// eslint-disable-next-line import/order
import type { LatestPrompt } from '../utils/xstate/get-ai-experience-service';
// eslint-disable-next-line import/order
import type { JSONDocNode } from '@atlaskit/editor-json-transformer';

export function useLocalizedLatestPrompt(latestPrompt: LatestPrompt | undefined): {
    presetTitle: string;
    userInput: string | undefined;
    userADFInput: JSONDocNode | undefined;
} | {
    userInput: string;
    userADFInput: JSONDocNode | undefined;
    presetTitle?: undefined;
} {
	const { formatMessage } = useIntl();

	return useMemo(() => {
		return latestPrompt?.presetTitle
			? {
					presetTitle: getTranslatedItemTitle(latestPrompt.presetTitle, formatMessage),
					userInput: latestPrompt?.userInput,
					userADFInput: latestPrompt?.userADFInput,
				}
			: {
					userInput: latestPrompt?.userInput || '',
					userADFInput: latestPrompt?.userADFInput,
				};
	}, [latestPrompt, formatMessage]);
}
